import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type ContactStore
 */
const initialState = {
  contactList: { loading: false, data: null, error: null },
};

export const ContactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    fetchContactListRequest: (state, action) => {
      state.contactList.loading = true;
      state.contactList.error = null;
    },
    fetchContactListSuccess: (state, action) => {
      state.contactList.data = action.payload;
      state.contactList.loading = false;
      state.contactList.error = null;
    },
    fetchContactListFailure: (state, action) => {
      state.contactList.data = null;
      state.contactList.loading = false;
      state.contactList.error = action.payload;
    },
  },
});

export const {
  fetchContactListRequest,
  fetchContactListSuccess,
  fetchContactListFailure,
} = ContactSlice.actions;

/**
 *
 * @param {*} store
 * @returns {ContactState['contactList']}
 */
export const getContactListState = (store) => store.contact?.contactList;

export default ContactSlice.reducer;
